import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import * as moment from "moment";
import { MotorDataDataService } from "src/app/share/data-service/motor.data.service";
import { MotorQuotationInterface } from "src/app/share/interface/motor-quotation.interface";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
  selector: "app-submit-success-dialog",
  templateUrl: "./submit-success-dialog.component.html",
  styleUrls: ["./submit-success-dialog.component.scss"]
})
export class SubmitSuccessDialogComponent {
  data: any;
  editQuotations: boolean = false;
  onOperation: boolean;
  responseTime: string = "5 - 20";
  channel;
  partnerCode: string;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    data: {
      content?: string;
      boldContent?: string;
      editQuotations?: boolean;
      customerInput: Partial<MotorQuotationInterface>;
      partnerCode?: string;
    },
    gtmService: GoogleTagManagerService,
    private motorDataService: MotorDataDataService,
    private partnerService: PartnerService
  ) {
    this.data = data;
    this.partnerCode = data.partnerCode;

    if (!this.partnerCode) {
      this.partnerService
        .getPartnerCode()
        .then((code) => (this.partnerCode = code));
    }
    this.editQuotations = data.editQuotations;
    gtmService.pushTag({
      event: "car_leads"
    });
    this.isOnOperation();
    this.channel = this.data.customerInput?.preferredChannel;
  }

  private isOnOperation() {
    this.motorDataService.checkIsOfficeHour().subscribe((response) => {
      this.onOperation = response === "YES";
    });
  }
}
